import React, {useState, useEffect} from 'react';

import {Column, Row} from '../../../components/layout';
import Header1 from '../../../components/headers/header1';
import './styles.scss';
import colors from '../../../util/colors';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {strings} from '../../../util/strings';
import moment from 'moment';
import {useHistory} from 'react-router-dom';
import {setWizard} from '../../../store/actions';
import {get} from '../../../api/api';
import {
  getPartialRefusalReasons,
  uriIreneCoverages,
  uriRefundDetails,
  uriRefundPaymentDetails,
  uriRefunds,
  uriStatuses,
} from '../../../api/endpoints';
import {createGUID, sortArrayByParam} from '../../../util/utility';
import {Expense} from '../../../components/expenses-detail/ExpensesDetail';
import ReimbursementsList from '../../reimbursements/reimbursement-history/components/ReimbursementsList';
import ReimbursementDetail from '../../reimbursements/reimbursement-history/components/ReimbursementsDetail';
import * as fonts from '../../../util/fonts';
import {LoadingOutlined} from '@ant-design/icons';

interface MyReimbursementsProps {
  labels: typeof strings.pt.refund;
  setWizard(values: any): void;
  selectedBu: any;
  availableBus: any[];
  setCurrency?(values: any): void;
}

export interface ReimbursementItem {
  auditNbr: string;
  catCode: string;
  catName: string;
  stateId: string;
  state: string;
  lastUpdate: string;
  providerName: string;
  clinicName: string;
  rede: string;
  isCat9: number;
  dosFrom: string;
  dosThru: string;
  amountPaid: number;
  sessionId: string;
  isSuccess: boolean;
  totalSteps: number;
  currentSteps: number;
  metadata?: any;
  processNbr?: any;
  currency: string;
}

export interface ReimbursementItemList {
  items: ReimbursementItem[];
}
export interface ReimbursementApiResponse {
  data: ReimbursementItemList;
  total: number;
  StatusCode: number;
}

function MyReimbursements({
  selectedBu,
  setWizard,
  labels,
  availableBus,
  setCurrency,
}: MyReimbursementsProps) {
  const [selectedItem, setSelectedItem] = useState<{
    auditNbr?: string;
    catCode?: string;
    catName?: string;
    stateId?: string;
    state?: string;
    lastUpdate?: string;
    providerName?: string;
    clinicName?: string;
    rede?: string;
    isCat9?: number;
    dosFrom?: string;
    dosThru?: string;
    submittedBy?: string;
    amountPaid?: number;
    sessionId?: string;
    processNbr?: string;
    checkDate?: string;
  }>({});
  const [refunds, setrefunds] = useState<ReimbursementApiResponse>();
  const [refundDetails, setrefundDetails] = useState<any[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [statuses, setstatuses] = useState<any[]>([]);
  const [completedSessionIdList, setCompletedSessionIdList] = useState<any[]>(
    [],
  );
  const [updateFlag, setUpdateFlag] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [ibanDetails, setIbanDetails] = useState('');
  const [loadingPaymentDetail, setLoadingPaymentDetail] = useState(false);

  const featureName = 'HomepageReimbursements';

  const history = useHistory();

  const changedItem = (filterItem: ReimbursementItem) => {
    if (filterItem.stateId === '101') {
      get(
        uriRefundDetails(
          selectedBu.buId,
          filterItem.auditNbr,
          filterItem.processNbr,
          filterItem.sessionId,
          filterItem.isCat9,
          filterItem.catCode,
        ),
        false,
        0,
        featureName,
      ).then((res: any) => {
        const metadata = res.data.refundsOcr.metadata;
        const patients = Object.keys(availableBus).map((key: any) => {
          const bu = availableBus[key];
          return {...bu, id: createGUID()};
        });
        const selectedPatient =
          patients.find(
            (patient) => !!patient.nif && patient.nif === metadata.nif,
          ) || patients[0];
        let patientValidation = {
          patients,
          ...selectedPatient,
        };

        const files = metadata.documents.map((document: any) => {
          const aux = (document.fileName as string)?.split('/');
          return {
            path: (aux && aux[aux.length - 1]) || document.fileName,
            preview: document.fileName,
            id: createGUID(),
            name: 'Fatura',
          };
        });
        setWizard({
          step: 2,
          patientValidation,
          attachFiles: {
            sessionId: filterItem.sessionId,
            files,
          },
          invoiceValidation: metadata,
        });
        history.push('/historico-reembolsos/pedido-reembolso', {
          downloadBlobs: true,
        });
      });
    } else {
      setShowModal(true);
      var newFilterItem = {...selectedItem};
      (newFilterItem as any) = filterItem;
      setSelectedItem(newFilterItem);
    }
  };

  const getListOfRefunds = async () => {
    const fromDate = moment(moment().subtract(6, 'month').toDate()).format(
      'YYYY-MM-DD',
    );
    const toDate = moment(moment().toDate()).format('YYYY-MM-DD');
    try {
      return await get(
        uriRefunds(
          selectedBu.buId,
          selectedBu.memId,
          0,
          fromDate,
          toDate,
          10000,
        ),
        false,
        0,
        featureName,
      );
    } catch (e: any) {
      return [];
    }
  };
  const getTheRefunds = () => {
    setIsLoading(true);
    if (selectedBu) {
      getListOfRefunds().then((res: any) => {
        setrefunds(res as ReimbursementApiResponse);
        setCurrency && setCurrency(res?.data?.items?.[0].currency || undefined);
        setIsLoading(false);
      });
    }
  };

  let statusId = selectedItem.stateId?.toLowerCase();
  let color = statuses.find((e) => e.value == statusId)?.colorCode;
  let maxItems = 2;

  useEffect(() => {
    async function getListOfStatuses() {
      return await get(uriStatuses(), false, 0, featureName);
    }

    getListOfStatuses().then((res: any) => {
      const statusOptions = (res.data?.items as any[])
        .filter((elem) => elem.stateName !== 'Default')
        .map((elem) => {
          return {
            value: elem.stateId,
            label: elem.stateName,
            colorCode: elem.color,
            stateId: elem.stateId,
          };
        });

      const sortedOptions = sortArrayByParam(statusOptions, 'label');

      setstatuses(sortedOptions);
    });
  }, []);

  useEffect(() => {
    if (selectedBu) {
      getTheRefunds();
    }
  }, [selectedBu.memId, updateFlag]);

  const ItemFinishedSubmitting = (sessionId: any) => {
    const alreadyFinished = !!completedSessionIdList.find(
      (elem) => elem === sessionId,
    );

    if (!alreadyFinished) {
      getTheRefunds();
      const newCompletedSessionIdList: any[] = [...completedSessionIdList];
      newCompletedSessionIdList.push(sessionId);
      setCompletedSessionIdList(newCompletedSessionIdList);
    }
  };

  useEffect(() => {
    async function getRefundDetails() {
      setLoadingDetail(true);
      let result: any = await get(
        uriRefundDetails(
          selectedBu.buId,
          selectedItem.auditNbr,
          selectedItem.processNbr,
          selectedItem.sessionId,
          selectedItem.isCat9,
          selectedItem.catCode,
        ),
        false,
        0,
        featureName,
      );
      return result.data;
    }
    if (showModal) {
      getRefundDetails()
        .then((res: any) => {
          const details: Expense[] = res.refunds?.map(
            ({
              catName,
              medicalAct,
              dos,
              amountClaimed,
              amountCopay,
              amountDeduct,
              amountDisallow,
              amountPaid,
              code,
              indicator,
              rejectedReason,
              currency,
              checkNbr,
              entryDate,
            }: any) => ({
              catName,
              medicalAct,
              dos,
              amountClaimed,
              amountCopay,
              amountDeduct,
              amountDisallow,
              amountPaid,
              code,
              indicator,
              rejectedReason,
              currency,
              checkNbr,
              entryDate,
            }),
          );
          //setrefundDetails(details);
          let aux: Expense[] = details;
          res.refunds.forEach((ref: any) => {
            if (ref.amountDisallow > 0) {
              get(
                getPartialRefusalReasons(selectedBu.buId, ref?.code),
                false,
                0,
                featureName,
              ).then((partialRefusalReason: any) => {
                if (partialRefusalReason?.data?.items?.length > 0) {
                  const index = res.refunds.indexOf(ref);
                  aux[index]['partialRefusalReason'] =
                    partialRefusalReason?.data?.items;
                }
              });
            }
            setrefundDetails(aux);
          });
          if (
            aux[0]?.checkNbr &&
            selectedItem.stateId === '6' &&
            selectedItem.amountPaid! >= 0.01
          ) {
            getRefundPaymentDetails(aux[0]?.checkNbr);
          }
        })
        .finally(() => {
          setLoadingDetail(false);
        });
    }
  }, [showModal]);

  const getRefundPaymentDetails = async (checkNbr: any) => {
    try {
      setLoadingPaymentDetail(true);
      let resultToFormat: any = await get(
        uriRefundPaymentDetails(selectedBu.buId, checkNbr),
        false,
        0,
        featureName,
      );
      if (resultToFormat?.data?.nib && labels.refundDetail_showIban === '1') {
        setIbanDetails(resultToFormat?.data?.nib);
      } else {
        setIbanDetails('');
      }
    } catch {
      setIbanDetails('');
    } finally {
      setLoadingPaymentDetail(false);
    }
  };

  return (
    <Column className="my-reimbursements-container">
      <Header1
        style={{...fonts.Bold, ...fonts.XL, color: colors.black}}
        className="my-reimbursements-header">
        {labels?.refundHistory_title}
      </Header1>
      <Row className="my-reimbursements-text-row">
        {labels?.refundHistory_text}
      </Row>
      <div className="my-reimbursements-body">
        {isLoading ? (
          <LoadingOutlined style={{fontSize: 24, marginTop: '50px'}} spin />
        ) : (
          <ReimbursementsList
            reimbursementItems={
              refunds &&
              refunds?.data &&
              refunds?.data?.items &&
              refunds.data.items.length > 0
                ? refunds.data.items
                : []
            }
            statuses={statuses}
            changedItem={changedItem}
            ReimbursementFinishedSubmitting={ItemFinishedSubmitting}
            maxItems={maxItems}
          />
        )}
      </div>
      <div className="expense-detail-modal">
        <ReimbursementDetail
          color={color}
          expenses={refundDetails}
          selectedItem={selectedItem}
          setShowModal={setShowModal}
          showModal={showModal}
          ReimbursementFinishedSubmitting={ItemFinishedSubmitting}
          setUpdateFlag={setUpdateFlag}
          updateFlag={updateFlag}
          checkdate={selectedItem.checkDate || ''}
          statuses={statuses}
          loadingDetail={loadingDetail || loadingPaymentDetail}
          loadingPaymentDetail={loadingPaymentDetail}
          ibanDetails={ibanDetails}
        />
      </div>
    </Column>
  );
}

const mapStateToProps = ({strings, selectedBu, availableBus}: any) => ({
  labels: strings.value.pt.refund,
  selectedBu: selectedBu.value,
  availableBus: availableBus.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(MyReimbursements),
);
